/* globals cookieControlSettings */

const config = {
  apiKey: cookieControlSettings.apiKey,
  product: cookieControlSettings.product,
  closeStyle: 'button',
  initialState: "closed",
  text: {
    closeLabel: 'Save and Close'
  },
  branding: {
    removeAbout: true
  },
  position: 'LEFT',
  theme: 'DARK'
}

module.exports = config
